import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'
import { Link } from 'react-router-dom'

class FaqItem extends Component {
  constructor (props) {
    super()
    this.state = {}
  }

  closeMenu = () => {
    var checkMenu = document.getElementById('menuToggle')
    if (checkMenu && checkMenu.checked === true) {
      checkMenu.checked = false
    }

    this.props.callReset()
  }

  render () {
    return (
      <div className='row align-items-center h-100 pos-relative mx-1'>
        <div className='col-12 px-0' onClick={() => this.closeMenu()}>
          <Link role='link' aria-label={this.props.text} to={this.props.path} className='btn btn-flat txt-font-body txt-body txt-initial txt-body txt-left py-half px-half link-font-mobile'>
            <div className='row align-items-center h-100 pos-relative' onClick={() => this.props.activePage()}>
              <div className='col-1 pl-0' aria-hidden='true'>
                <div className='row mx-0'>
                  <div className='col-auto px-0 mx-auto'>
                    <Icon iconName={`icon ${this.props.icon} pos-relative icon-menu-mobile`} />
                  </div>
                </div>
              </div>
              <div className='col py-0 px-0 pl-half ml-1' aria-hidden='true'>
                {this.props.text}
              </div>
            </div>
          </Link>
        </div>
      </div>
    )
  }
}

FaqItem.propTypes = {
  callReset: PropTypes.func.isRequired,
  activePage: PropTypes.func,
  text: PropTypes.string,
  icon: PropTypes.string,
  path: PropTypes.string
}

export default FaqItem



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/Faq/FaqItem.js